import React, { useEffect, useState } from 'react'
import { trackPromise } from 'react-promise-tracker'
import LoadingWrapper from 'components/LoadingWrapper'
import { withRouter } from 'react-router-dom'

import { UpdateClient } from 'store/ClientsApiClient'
import ManageClient from '../../components/ManageClient'
import ManageClientSidebar from '../../components/ManageClientSidebar'
import { MainContent } from '../../../../layouts/components/Structure'
import IpsaSidebar from '../../../../layouts/IpsaSidebar'
import { GetClient } from '../../../../store/ClientsApiClient'

const EditClient = ({ history, id }) => {
    const PromiseArea = 'client-edit'
    const [error, setError] = useState(null)
    const [client, setClient] = useState(null)

    const saveClient = (values, redirect) => {
        trackPromise(
            UpdateClient(id, values)
                .then(() => {
                    if (redirect) {
                        history.push(redirect)
                    } else {
                        GetClientInformation()
                    }
                })
                .catch((err) => {
                    setClient(client)
                    setError(err)
                })
                .finally(() => {}),
            PromiseArea
        )
    }

    const GetClientInformation = () => {
        trackPromise(
            GetClient(id)
                .then((resp) => {
                    const { data } = resp
                    setClient(data)
                })
                .catch((err) => {
                    setError(err)
                })
                .finally(() => {}),
            PromiseArea
        )
    }

    useEffect(() => {
        GetClientInformation()
    }, [id])

    const {
        client: { firstName, lastName },
    } = client || { client: { firstName: '', lastName: '' } }
    return (
        <>
            <IpsaSidebar>
                <ManageClientSidebar />
            </IpsaSidebar>
            <MainContent>
                {client && (
                    <div className="col-section col-no-margin">
                        <div className="col-xs-6">
                            <h1>
                                Edit: {firstName} {lastName}
                            </h1>
                        </div>
                        <div className="col-xs-6"></div>
                    </div>
                )}
                <LoadingWrapper area={PromiseArea}>
                    {client && (
                        <ManageClient
                            clientId={id}
                            formState={client}
                            onSubmit={(values) => {
                                saveClient(values, `/clients/${id}/presentation/income`)
                            }}
                            onSave={(values) => {
                                saveClient(values, '')
                            }}
                        ></ManageClient>
                    )}
                    {error && <p className="error">{error}</p>}
                </LoadingWrapper>
            </MainContent>
        </>
    )
}

export default withRouter(EditClient)
